import { createTalkStore } from "@mgdx/talk/stores/talkStore";
import { createVideoCallingStore } from "@mgdx/video-calling/stores/videoCallingStore";

export const talkStore = createTalkStore({ persistent: true });
export const videoCallingStore = createVideoCallingStore({ persistent: true });

// 他の store と同じく初回の描画より前に復元し、描画中の変更が復元で上書きされないようにする
if (typeof window !== "undefined") {
  void talkStore.persist.rehydrate();
  void videoCallingStore.persist.rehydrate();
}
